import { FunctionComponent, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { Text } from '@conexasaude/conexa-hero'
import Modal from '@/components/Modal'
import { Illustration } from '@/components/HideIllustrationsExternal'

import { useStyles } from './styles'

const RescheduledByMedicModal: FunctionComponent = () => {
  const history = useHistory()
  const styles = useStyles()

  const handleDismiss = () => {
    history.push('/', {
      from: 'RESCHEDULED_BY_MEDIC_MODAL',
    })
  }

  const goAppointment = useCallback(() => {
    history.push('/meus-atendimentos', {
      from: 'RESCHEDULED_BY_MEDIC_MODAL',
    })
  }, [history])

  return (
    <Modal
      id="RESCHEDULED_BY_MEDIC"
      onDismiss={handleDismiss}
      primaryActionLabel="Minhas consultas"
      primaryAction={goAppointment}
    >
      <div css={styles.content}>
        <Text>
          Sua consulta foi reagendada pelo profissional de saúde. Veja a nova
          data da consulta em “Minhas consultas”.
        </Text>
        <div css={styles.illustration}>
          <Illustration name="medic-calendar" width="205px" />
        </div>
      </div>
    </Modal>
  )
}

export default RescheduledByMedicModal
